import { NetworthSummaryTimeframe } from 'interfaces/networth'

export const NETWORTH_SUMMARY_TIMEFRAMES_MAP: Record<NetworthSummaryTimeframe, { title: string }> = {
  last_month: {
    title: 'Last Month',
  },
  since_last_login: {
    title: 'Since Last Login',
  },
  this_month: {
    title: 'This Month',
  },
  last_6_months: {
    title: 'Last 6 Months',
  },
}

export const NETWORTH_SUMMARY_TIMEFRAMES = Object.keys(NETWORTH_SUMMARY_TIMEFRAMES_MAP) as NetworthSummaryTimeframe[]
